module.exports = __webpack_public_path__ + "assets/icons-misc-elipsis-24-px.070d1c75.svg";